import { TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getCommonCodeLabel } from '../../../lib/store';
import { IRefundedItemTodo, IRefundedOrderTodo } from '../../../models/refunds.model';

export default function ColumnsCollection(): [typeof Columns1, typeof Columns2] {
  const { t } = useTranslation();

  const isWithin90Days = (paymentDttm: string): boolean => {

    if (paymentDttm) return false; // 데이터가 없거나 firstRegDttm이 없으면 false

    const firstRegDate = new Date(paymentDttm); // 등록 날짜
    const today = new Date(); // 현재 날짜
    const diffTime = today.getTime() - firstRegDate.getTime(); // 밀리초 차이
    const diffDays = diffTime / (1000 * 60 * 60 * 24); // 일(day) 단위로 변환

    return diffDays <= 90; // 90일 이내인지 확인
  };

  const Columns1: TableColumnsType<IRefundedOrderTodo> = [
    {
      title: t('student.student.column105'),
      dataIndex: 'refundAmount',
      key: 'refundAmount',
      align: 'center',
      sorter: (a, b) => a.refundAmount - b.refundAmount,
      render: value => value?.toLocaleString(),
    },
    {
      title: t('student.student.column106'),
      dataIndex: 'calculateReasonCode',
      key: 'calculateReasonCode',
      align: 'center',
      sorter: (a, b) => a.calculateReasonCode.localeCompare(b.calculateReasonCode),
      render: value => getCommonCodeLabel('PA0008', value, 'ko'),
    },
    {
      title: t('결제 일시'),
      dataIndex: 'paymentDttm',
      key: 'paymentDttm',
      align: 'center',
      sorter: (a, b) => a.paymentDttm.localeCompare(b.paymentDttm),
      render: value => moment(value).format('YYYY.MM.DD HH:mm:ss'),
    },
    {
      title: t('student.student.column41'),
      dataIndex: 'firstRegDttm',
      key: 'firstRegDttm',
      align: 'center',
      sorter: (a, b) => a.firstRegDttm.localeCompare(b.firstRegDttm),
      render: value => moment(value).format('YYYY.MM.DD HH:mm:ss'),
    },
    {
      title: t('환불 가능 여부'),
      key: 'refundPSBYn',
      align: 'center',
      render: (_, record, index) => isWithin90Days(record.paymentDttm) ? 'N' : 'Y',
    },
    {
      title: t('student.student.column44'),
      dataIndex: 'memberName',
      key: 'memberName',
      align: 'center',
      sorter: (a, b) => a.memberName.localeCompare(b.memberName),
    },
  ];

  const Columns2: TableColumnsType<IRefundedItemTodo> = [
    {
      title: t('student.student.column22'),
      dataIndex: 'semesterName',
      key: 'semesterName',
      align: 'center',
      sorter: (a, b) => a.semesterName.localeCompare(b.semesterName),
    },
    {
      title: t('student.student.column48'),
      dataIndex: 'monthNameCode',
      key: 'monthNameCode',
      align: 'center',
      sorter: (a, b) => a.monthNameCode.localeCompare(b.monthNameCode),
      render: (value: string) => getCommonCodeLabel('SY0009', value?.trim() || '', 'ko'),
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
      sorter: (a, b) => a.className.localeCompare(b.className),
    },
    {
      title: t('student.student.column107'),
      dataIndex: 'paymentTargetCode',
      key: 'paymentTargetCode',
      align: 'center',
      sorter: (a, b) => a.paymentTargetCode.localeCompare(b.paymentTargetCode),
      render: (value: string) => getCommonCodeLabel('PA0001', value, 'ko'),
    },
    // {
    //   title: '결제금액',
    //   dataIndex: 'price',
    //   key: 'price',
    //   align: 'center',
    //   sorter: (a, b) => a.price - b.price,
    //   render: (value: number) => value?.toLocaleString(),
    // },
    {
      title: t('student.student.column108'),
      dataIndex: 'paymentCompleteAmount',
      key: 'paymentCompleteAmount',
      align: 'center',
      sorter: (a, b) => a.paymentCompleteAmount - b.paymentCompleteAmount,
      render: (value: number) => value?.toLocaleString(),
    },
  ];
  return [Columns1, Columns2];
}